
  <h3 mat-dialog-title class="align-center semi-bold">{{ (hasPickPack ? 'App.ReceiptPopup.SendReceiptAndPickPack' : 'App.ReceiptPopup.SendReceipt') | translate }}</h3>
  
  <div mat-dialog-content class="dropoff-receipt-popup">
    <!-- Handoff -->
    <div @fadeAnimation *ngIf="step === 0" class="semi-bold content">
      <img src="./img/dropoff-receipt-tablet.svg" alt="Tablet" class="handoff-img" />
      <p class="align-center pt--sm">
        {{ 'App.ReceiptPopup.Handoff1' | translate }}<br />
        {{ 'App.ReceiptPopup.Handoff2' | translate }}
      </p>
    </div>

    <!-- Phone / Email form -->
    <div @fadeAnimation *ngIf="step === 1">
      <p *ngIf="hasPickPack" class="mt--none mb--xs align-center text-medium color--danger"><i>{{ 'App.ReceiptPopup.PickPackRewardsInfo' | translate }}</i></p>      
      <form [formGroup]="receiptForm" class="mb--sm">  
        <mat-radio-group formControlName="method">
          <mat-radio-button *ngIf="!hasPickPack" value="sms">
            {{ 'App.ReceiptPopup.SMSOption' | translate }}
          </mat-radio-button>
          <mat-form-field *ngIf="!hasPickPack" appearance="outline" class="w-100">
            <input
              (focus)="selectMethod('sms')"
              matInput
              formControlName="phone"
              placeholder="{{ 'App.ReceiptPopup.PhonePlaceholder' | translate }}"
              inputmode="tel"
              (keypress)="allowOnlyNumberAndHyphen($event)"
            />
            <mat-error *ngIf="receiptForm.get('phone')?.hasError('pattern')">
              {{ 'App.ReceiptPopup.InvalidPhone' | translate }}
            </mat-error>
          </mat-form-field>

          <mat-radio-button value="email">
            {{ 'App.ReceiptPopup.EmailOption' | translate }}
          </mat-radio-button>
          <mat-form-field appearance="outline" class="w-100">
            <input
              (focus)="selectMethod('email')"
              matInput
              formControlName="email"
              placeholder="{{ 'App.ReceiptPopup.EmailPlaceholder' | translate }}"
            />
            <mat-error
              *ngIf="receiptForm.get('email')?.hasError('pattern') || receiptForm.get('email')?.hasError('email')"
            >
              {{ 'App.ReceiptPopup.InvalidEmail' | translate }}
            </mat-error>
          </mat-form-field>
        </mat-radio-group>

        <mat-checkbox formControlName="optIn">
          {{ 'App.ReceiptPopup.MarketingOptIn' | translate }}
        </mat-checkbox>
      </form>
    </div>

    <!-- Thank-you with check animation -->
    <div @fadeAnimation *ngIf="step === 2" class="align-center">
      <img src="./img/animations/checkmark-animation.gif" width="190" alt="Success" />
      <p class="mt--md semi-bold">
        {{ 'App.ReceiptPopup.ThankYouMessage' | translate }}
        <span *ngIf="carrierLabel">{{ carrierLabel }}</span>
        {{ pkgWord | translate }}
        <span class="semi-bold">{{ trackingList }}</span>
        <span *ngIf="data.storeName">
          {{ 'App.ReceiptPopup.AtStore' | translate }} {{ data.storeName }} {{ 'App.ReceiptPopup.Today' | translate }}.
        </span>
      </p>
      <p class="semi-bold mt--sm">{{ 'App.ReceiptPopup.ReturnDevice' | translate }}</p>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <!-- Send email -->
    <ng-container *ngIf="step === 1">
      <button
        mat-button
        class="primary-button rounded w-100 mb--md"
        [disabled]="
          receiptForm.invalid ||
          (receiptForm.value.method === 'sms' && !receiptForm.value.phone) ||
          (receiptForm.value.method === 'email' && !receiptForm.value.email)
        "
        (click)="send()"
      >
        {{ 'App.ReceiptPopup.SendReceiptButton' | translate }}
      </button>
    </ng-container>
    <button *ngIf="step === 0" mat-button class="primary-button rounded w-100" (click)="step = 1">
      {{ 'App.ReceiptPopup.Next' | translate }}
    </button>
    <button *ngIf="step === 1" mat-button class="hollow-button rounded w-100" (click)="close()">
      {{ 'App.ReceiptPopup.Cancel' | translate }}
    </button>
    <button *ngIf="step === 2" mat-button class="primary-button rounded w-100" (click)="close(true)">
      {{ 'App.ReceiptPopup.Done' | translate }}
    </button>
  </div>
